<template>
  <div class="USPS-parent" id="usps">
    <h2>{{ benefit.benefitTitle }}</h2>

    <div class="USPS">
      <div class="USPS__element" v-for="(item, index) in benefits" :key="index">
        <div class="USPS__circle">
          <img :class="item.class" :src="item.icon" alt="Ikon" />
        </div>
        <p>{{ item.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
const ICONS = [
  { icon: require("@/assets/elements/cutlery.png") },
  { icon: require("@/assets/elements/bowl-hot.png") },
  { icon: require("@/assets/elements/user-chef.png") },
  { icon: require("@/assets/elements/clock.png") },
  {
    icon: require("@/assets/elements/credit-card.png"),
    class: "USPS__credit-card",
  },
  { icon: require("@/assets/elements/sliders.png") },
  { icon: require("@/assets/elements/award.png"), class: "USPS__award" },
  { icon: require("@/assets/elements/smile.png") },
];

export default {
  props: {
    benefit: Object,
  },
  computed: {
    benefits() {
      return ICONS.map((item, index) => ({
        class: item.class || "USPS__icon",
        icon: item.icon,
        text: this.benefit[`benefit${index + 1}`],
      }));
    },
  },
};
</script>

<style lang="scss">
.USPS-parent {
  margin: auto;
  text-align: center;
  padding-top: 7.5rem;
  padding-bottom: 7.5rem;
}

.USPS {
  margin: auto;
  margin-top: 3rem;

  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  gap: 2rem;

  width: 100%;
  max-width: 1100px;

  @media (max-width: $tablet) {
    justify-content: center;
    max-width: 800px;
  }

  &__element {
    width: 250px;

    p {
      text-align: center;
      margin-top: 1rem;
      font-size: 1.25rem;
    }

    @media (max-width: $tablet) {
      width: 165px;
    }
  }

  &__circle {
    margin: auto;

    width: 100px;
    height: 100px;
    background-color: var(--primary);
    border-radius: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__icon {
    width: 50px;
    height: 50px;
  }

  &__credit-card {
    width: 57px;
    height: 50px;
  }

  &__award {
    width: 38px;
    height: 50px;
  }
}
</style>
